// Keep BigDec and the deep renderer out of the initial page bundle. A failed
// request is retryable (for example after an offline connection is restored).
let pending;
let loadedModule = null;

export function getLoadedDeepZoom() {
  return loadedModule;
}

export function loadDeepZoom() {
  if (!pending) {
    pending = import('./DeepFractalCanvas')
      .then(module => {
        loadedModule = module;
        return module;
      })
      .catch(error => {
        pending = null;
        throw error;
      });
  }
  return pending;
}

// Switch while adjacent GPU pixels still have several representable values.
// The CPU fallback uses the same threshold for consistent navigation behavior.
const INV_PRECISION_THRESHOLD = 2 ** -21;

function axisNeedsDeepZoom(range, pixels) {
  const r0 = range[0];
  const r1 = range[1];
  const span = r1 - r0;
  const abs0 = r0 < 0 ? -r0 : r0;
  const abs1 = r1 < 0 ? -r1 : r1;
  const maxAbs = abs0 > abs1 ? abs0 : abs1;
  const magnitude = maxAbs > 1e-30 ? maxAbs : 1e-30;
  return span > 0 && span < pixels * magnitude * INV_PRECISION_THRESHOLD;
}

export function needsDeepZoom(xRange, yRange, width, height) {
  const spanX = xRange[1] - xRange[0];
  const spanY = yRange[1] - yRange[0];
  if (!Number.isFinite(spanX) || !Number.isFinite(spanY)
    || !(spanX > 0 && spanX <= 1e4) || !(spanY > 0 && spanY <= 1e4)) {
    return false;
  }
  return axisNeedsDeepZoom(xRange, width) || axisNeedsDeepZoom(yRange, height);
}
